/*
 * WHERE A PASSAGE'S OWN NAME IS FILED, for everything that needs to ask.
 *
 * "Isaiah 53" names its book. "Quran 2" does not name Al-Baqara, and the library has held all 114
 * surah names the whole time. `Bundle.sections` carries the ones a reference does not say, keyed by
 * the function below.
 *
 * IT LIVES IN `schema` BECAUSE THREE PLACES ASK IT. The pipeline derives the map over the corpus,
 * the static pages read it per passage, and the app reads it per passage again — and a key built in
 * three places is a rule stated three times. It was written in `pipeline/lib/section-names.ts`
 * first, where the app could not reach it, which is exactly how a reader came to see "Quran 2" on
 * the surface most people use while the crawler surface said "Surah 2 Al-Baqara".
 */
import { bookOfRef, chapterOfRef } from './derive.js';

/**
 * The key a passage is filed under — corpus, the book its reference names, and the chapter.
 *
 * A CHAPTER-LEVEL REFERENCE IS ALREADY THE ANSWER, and asking `bookOfRef` for one gets it wrong.
 * `TAIL` in `derive.ts` needs a chapter AND a verse, so "Quran 2:255" splits into "Quran" and "2"
 * while "Quran 2" splits into "Quran 2" and nothing — giving a key with a trailing space that
 * matches neither. The build reads verses and a page reads passages, so the two sides ask this in
 * different forms and would otherwise have silently agreed on nothing: no section, no error, and no
 * failing test unless one was written for exactly this.
 */
export function sectionKey(corpus: string, ref: string): string {
  const chapter = chapterOfRef(ref);
  return chapter === '' ? `${corpus}|${ref}` : `${corpus}|${bookOfRef(ref)} ${chapter}`;
}
